module.exports = __webpack_public_path__ + "static/img/11.3640da8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/sp/11.png
// module id = Z8yW
// module chunks = 0